import { createEmits } from '../utils/emits';

interface Events {
  // Step 组件仅用于展示，不支持交互事件
}

const {
  defineEmitType,
  useEmits,
} = createEmits<Events>();

export {
  useEmits,
};

export const emits = defineEmitType([
  // Step 组件仅用于展示，不支持交互事件
]);
